import { __rest } from 'tslib';
import React, { Component } from 'react';
import { evaluate } from '@tencent/workbench';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import styles from './form-button.less.js';

class FormButton extends Component {
    constructor() {
        super(...arguments);
        this.clickHandler = () => {
            var _a, _b;
            (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
    }
    render() {
        const _a = this.props, { label, tooltip, disabled } = _a, item = __rest(_a, ["label", "tooltip", "disabled"]);
        const tooltipText = evaluate(tooltip, null);
        const value = evaluate(item.value, false);
        const options = evaluate(this.props.options, {});
        const style = evaluate(item.style, {});
        const classnames = [];
        if (value) {
            classnames.push(styles.active);
        }
        if (disabled) {
            classnames.push(styles.disabled);
        }
        if (options === null || options === void 0 ? void 0 : options.borderless) {
            classnames.push(styles.borderless);
        }
        return React.createElement(Tooltip, { title: tooltipText, disabled: !tooltipText, className: styles.wrapper, overlayHoverable: false, style: style },
            React.createElement("button", { onClick: this.clickHandler, className: classnames.join(' '), "aria-disabled": disabled }, options === null || options === void 0 ? void 0 :
                options.icon,
                React.createElement("span", null, options === null || options === void 0 ? void 0 : options.text)),
            label && React.createElement("label", null, label));
    }
}

export { FormButton };
//# sourceMappingURL=form-button.js.map
